import { ErrorTypes } from '../../../../@types/api-response';

export interface ErrorModalConfig {
  error?: number;
  title: string;
  description?: string;
  buttonText: string;
  imageUrl: string;
  isShowButton: boolean;
  isLogoutUser?: boolean;
  redirectTo?: string;
  needToCloseTradingModal?: boolean;
  isFullWidthButton?: boolean;
}

/* eslint-disable import/prefer-default-export */
export const errorInfoList: ErrorModalConfig[] = [
  {
    error: 401,
    imageUrl: '/img/session-time-out.svg',
    title: 'Sesi Kamu Sudah Habis',
    description: 'Silahkan login kembali untuk melanjutkan',
    isShowButton: true,
    buttonText: 'Kembali ke Halaman Utama',
    isLogoutUser: true,
  },
  {
    error: 500,
    imageUrl: '/img/internal-server-error.svg',
    title: 'Kendala pada Server',
    description:
      'Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.',
    isShowButton: true,
    buttonText: 'Tutup',
  },
  {
    error: 503,
    imageUrl: '/img/maintenance-mode.svg',
    title: 'Maintenance Sedang Berlangsung',
    description:
      'Stockbit sedang menjalankan maintenance, cobalah beberapa saat lagi.',
    isShowButton: true,
    buttonText: 'Kembali ke Halaman Utama',
  },
];

export type TradingErrorModalConfigKey =
  | 'sessionExpired'
  | 'maintenance'
  | 'dailyMaintenance'
  | 'systemError'
  | 'userSuspend';

export const tradingErrorModalConfig: Record<
  TradingErrorModalConfigKey,
  ErrorModalConfig
> = {
  sessionExpired: {
    imageUrl: '/img/session-time-out.svg',
    title: 'Sesi Kamu Sudah Habis',
    description: 'Silahkan login kembali untuk melanjutkan',
    buttonText: 'Kembali ke Halaman Utama',
    isShowButton: true,
    isLogoutUser: true,
  },
  maintenance: {
    imageUrl: '/img/maintenance-mode.svg',
    title: 'Pemeliharaan Sedang Berlangsung',
    buttonText: 'Kembali ke Halaman Utama',
    isShowButton: false,
  },
  dailyMaintenance: {
    imageUrl: '/img/daily-maintenance.svg',
    title: 'Persiapan Harian',
    buttonText: 'Kembali ke Halaman Utama',
    isShowButton: false,
  },
  systemError: {
    imageUrl: '/img/internal-server-error.svg',
    title: 'Kendala pada Server',
    description:
      'Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.',
    buttonText: 'Tutup',
    isShowButton: true,
  },
  userSuspend: {
    imageUrl: '/img/trading-limit-user-suspended.svg',
    title: 'Tidak Dapat Melakukan Transaksi',
    description: 'Deposit atau jual saham untuk melakukan transaksi.',
    buttonText: 'Deposit Sekarang',
    isShowButton: true,
    redirectTo: '/securities/deposit',
    needToCloseTradingModal: true,
    isFullWidthButton: true,
  },
};

type TradingErrorModalList = Record<
  number,
  Partial<
    Record<
      ErrorTypes | 'NO_SERVER_RESPONSE',
      keyof typeof tradingErrorModalConfig
    >
  >
>;

export const tradingErrorModalList: TradingErrorModalList = {
  401: {
    NO_SERVER_RESPONSE: 'sessionExpired',

    INVALID_AUTH: 'sessionExpired',
    // checkov:skip=<CKV_SECRET_6> "false positive, no secret TOKEN exposed here"
    INVALID_TOKEN: 'sessionExpired',
    INVALID_SESSION: 'sessionExpired',
    MOCK_TRADING: 'sessionExpired',
    MAINTENANCE_MODE: 'maintenance',
    DAILY_MAINTENANCE_MODE: 'dailyMaintenance',
    UNAUTHORIZED: 'sessionExpired',
  },
  403: {
    USER_SUSPEND: 'userSuspend',
    USER_SUSPEND_BACK_OFFICE: 'userSuspend',
  },
  503: {
    MAINTENANCE_MODE: 'maintenance',
    DAILY_MAINTENANCE_MODE: 'dailyMaintenance',
  },
  500: {
    SYSTEM_ERROR: 'systemError',
  },
};
